import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

type ErrorResponseType = {
  status: boolean
  message: string
  code: number
}

export type LockSequencePoolOrderType = {
  pool_number: number | string
  order_id: number
  pool_id: number
}

export type LockSequencePoolingPayloadType = {
  orders: LockSequencePoolOrderType[]
  location_id: number
}

export type LockSequencePoolingInfoPayloadType = {
  pools: LockSequencePoolingPayloadType[]
}

export type LockSequencePoolingMutationResponseType = {
  pool_number: number | string
  pool_id: number
  error: ErrorResponseType
}

export type LockSequencePoolingInfoDeliveryType = {
  delivery: {
    delivery_order_id: number
    order_id: number
    items: {
      total_qty: number
      total_sku: number
      total_weight: number
      total_volume: number
    }
    delivery_option: {
      timing_id: number
      timing_desc: string
      additional_sla: {
        min_duration: number
        max_duration: number
        note: string
      }
    }
    destination: {
      receiver: {
        id: number
        name: string
        is_new_buyer?: boolean
      }
      address: {
        id: number
        address: string
        latitude: number
        longitude: number
      }
      route: {
        distance: number
        shape: string
      }
    }
    status: string
  }
  payment_at: number
  pool_id: number
  pool_number: string
}

export type LockSequencePoolingInfoDataType = {
  orders: {
    deliveries: LockSequencePoolingInfoDeliveryType[]
  }[]
}

export type LockSequencePoolingInfoResponseType = {
  data: LockSequencePoolingInfoDataType
  error: ErrorResponseType
}

export const putLockSequenceTagPooling = (payload: LockSequencePoolingPayloadType) =>
  axiosInstanceApiGateway.Put<
    LockSequencePoolingMutationResponseType | LockSequencePoolingMutationResponseType[],
    true
  >({
    url: '/logistic/internal/v1/admin/pooling/tag',
    data: payload,
  })

export const putLockSequenceUntagPooling = (payload: LockSequencePoolingPayloadType) =>
  axiosInstanceApiGateway.Put<
    LockSequencePoolingMutationResponseType | LockSequencePoolingMutationResponseType[],
    true
  >({
    url: '/logistic/internal/v1/admin/pooling/untag',
    data: payload,
  })

export const getLockSequencePoolingInfo = (payload: LockSequencePoolingInfoPayloadType) =>
  axiosInstanceApiGateway.Post<LockSequencePoolingInfoResponseType, true>({
    url: '/logistic/internal/v1/admin/pooling/information',
    data: payload,
  })
